import { createEffect } from 'effector';
import io from "socket.io-client";

export interface ConnectSocketPayload {
	baseUrl?: string;
	bearer?: string;
}

export function createSocket() {
	const instance = io({ autoConnect: false });

	const connect = createEffect({
		handler: ({ baseUrl, bearer }: ConnectSocketPayload) => {
			instance.io.uri = baseUrl;

			if (bearer) {
				instance.io.opts.transportOptions = getTransportOptions(bearer);
			}

			instance.connect();
		}
	});
	const emit = createEffect<{ event: string, body?: any }, void>({
		handler: (payload) => {
			instance.emit(payload.event, payload.body)
		},
	});
	const on = (event: string, cb: Function) => {
		instance.on(event, cb);
	};
	const disconnect = createEffect({
		handler: () => {
			setTimeout(() => {
				instance.disconnect();
			}, 500)
		}
	})

	return {instance, connect, disconnect, emit, on};
}

function getTransportOptions(token) {
	return {
		polling: {
			extraHeaders: {
				'Authorization': `Bearer ${token}`
			}
		}
	}
}
